// import { createSlice } from '@reduxjs/toolkit'

// export const addToCartSlice = createSlice({
//   name: 'addToCart',
//   initialState: {
//     value: 0,
//   },
//   reducers: {
//     addToCart: (state) => {
//       state.value += 1
//     },

//   },
// })

// // Action creators are generated for each case reducer function
// export const { addToCart } = addToCartSlice.actions

// export default addToCartSlice.reducer
import { ADD_TO_CART } from "../actions/actionTypes";

const initialState = [];

export const addToCartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART:
      return action.payload;
    default:
      return state;
  }
};
